var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"form-creator-info",class:_vm.answerContainerClass},[_c('p',[_vm._v(_vm._s(_vm.label))])])
}
var staticRenderFns = []

export { render, staticRenderFns }